<template>
  <main>
    <HomepageDashboard />
    <section class="homepage-content">
      <div class="container">
        <HomepageTutorial />
        <HomepageFAQ />
      </div>
    </section>
  </main>
</template>

<script>
import HomepageDashboard from './HomepageDashboard.vue';
import HomepageFAQ from './HomepageFAQ.vue';
import HomepageTutorial from './HomepageTutorial.vue';

export default {
  components: {
    HomepageDashboard,
    HomepageFAQ,
    HomepageTutorial,
  },
};
</script>

<style lang="scss">
@import "~@/assets/scss/variables.scss";

.homepage-content {
  position: relative;
  .content-container {
    position: relative;
    width: 100%;
    margin-bottom: $spacer * 4;
    .content-group {
      position: relative;
      width: 100%;
      margin-bottom: $spacer;
      .content-image {
        position: relative;
        width: 100%;
        max-width: 1200px;
        margin-bottom: $spacer;
      }
    }
  }
}
</style>
